module.exports = __webpack_public_path__ + "img/cassette_still.0b7075d9.gif";